<app-commissioning-spinner
  [title]="pairingTitle"
  [message]="pairingDescription"
></app-commissioning-spinner>
